import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import React, { memo } from 'react'

import { MediaContextProvider } from './media'

export type Theme = typeof theme

export const theme = {
  colors: {
    variants: {
      neutralLight5: '#FFFFFF',
      neutralLight4: '#F2F2F2',
      neutralDark4: '#9D8D90',
      neutralDark3: '#1F1F1F',
      neutralDark2: '#141414',
      neutralDark1: '#000000',
      primaryDark: '#A3A03E',
      primaryLight: '#B2AE3B',
      secondaryLight: '#3C6480',
      dangerDark: '#E07355',
      danger: '#EB7A5C',
    },
  },
  fontFamily: {
    heading: "'Jost', sans-serif",
    paragraph: "'Barlow Condensed', sans-serif",
  },
}

export const ThemeProvider = memo(function ThemeProvider({ children }: any) {
  return (
    <EmotionThemeProvider theme={theme}>
      <MediaContextProvider>{children}</MediaContextProvider>
    </EmotionThemeProvider>
  )
})
